import React from 'react'
import dynamic from 'next/dynamic'
import styles from '@/styles/About.module.css'
import { useTranslation } from 'react-i18next'

const GruppOne = dynamic(() => import('./GruppOne'))
const GruppTwo = dynamic(() => import('./GruppTwo'))
const GruppThree = dynamic(() => import('./GruppThree'))
const GruppFour = dynamic(() => import('./GruppFour'))
const GruppFive = dynamic(() => import('./GruppFive'))
const Mexikanska = dynamic(() => import('./Mexikanska'))
const Italienska = dynamic(() => import('./Italienska'))
const PanPizza = dynamic(() => import('./PanPizza'))

const Pizza = () => {
  const { t } = useTranslation()

  return (
    <section className={styles.pizzaGroupWrapper}>
      <header className={styles.pizzaGroupHeader}>
        <h1 className={styles.pizzaTitle}>Pizza Meny</h1>
        <p className={styles.headerPara}>
          {t('All pizzas include tomato sauce and cheese')}
        </p>
      </header>
      <main className={styles.pizzaSection}>
        <GruppOne />
        <GruppTwo />
        <GruppThree />
        <GruppFour />
        <GruppFive />
        {/* <GruppSix /> */}
        <Mexikanska />
        <Italienska />
        <PanPizza />
      </main>
    </section>
  )
}

export default Pizza
